import React, { useState } from 'react';
import Navbar from './layout/Navbar';
import Footer from './layout/Fotter';
import ContactImage from '../assets/contact-image.jpg';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    productInterest: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error for the field when user starts typing
    setErrors({
      ...errors,
      [name]: '',
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Full name is required';
    } else if (formData.name.length < 2) {
      newErrors.name = 'Name must be at least 2 characters long';
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Phone validation
    const phoneRegex = /^\+?[\d\s-]{10,}$/;
    if (!formData.phone) {
      newErrors.phone = 'Phone number is required';
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number (at least 10 digits)';
    }

    // Subject validation
    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.length < 10) {
      newErrors.message = 'Message must be at least 10 characters long';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Handle form submission (e.g., API call)
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you soon.');

    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      productInterest: '',
    });
    setErrors({});
  };

  // Function to prevent right-click and dragging
  const preventDefault = (e) => {
    e.preventDefault();
  };

  const productCategories = [
    'GVT (Glazed Vitrified Tiles)',
    'PGVT (Polished Glazed Vitrified Tiles)',
    'MATT Finish Tiles',
    'HIGH GLOSS Ceramic Tiles',
    'CARVING Design Tiles',
    'WOODEN Look Tiles',
    'General Inquiry',
  ];

  return (
    <div className="w-full overflow-hidden select-none" onContextMenu={preventDefault}>
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="py-12 sm:py-16 lg:py-20 select-none">
        <div className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh] bg-gradient-to-r from-gray-900 to-gray-700 select-none">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat select-none"
            style={{
              backgroundImage: `url(${ContactImage})`,
              backgroundBlendMode: 'overlay',
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
            }}
            onContextMenu={preventDefault}
            onDragStart={preventDefault}
          ></div>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
          <div className="relative z-20 h-full flex items-center justify-center select-none">
            <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6 select-none">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 select-none">
                Contact GMC Ceramic
              </h1>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light leading-relaxed select-none">
                Get in touch with our experts for personalized tile solutions and professional guidance
              </p>
              <div className="mt-4 sm:mt-6 lg:mt-8 select-none">
                <div className="w-16 sm:w-20 lg:w-24 h-1 bg-orange-500 mx-auto"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 select-none">
            {/* Address */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 text-center hover:shadow-xl transition-transform transform hover:scale-105 duration-300 select-none">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 select-none">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 sm:mb-3 select-none">Visit Our Company</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed select-none">
                GMC Ceramic Company<br />
                123 Ceramic Street<br />
                Morbi, Gujarat 363641<br />
                India
              </p>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 text-center hover:shadow-xl transition-transform transform hover:scale-105 duration-300 select-none">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 select-none">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 sm:mb-3 select-none">Call Us</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed select-none">
                Sales: +91 9106977695<br />
                Support: +91 8575185755<br />
                WhatsApp: +91 8575185755<br />
                Mon - Sat: 9:00 AM - 6:00 PM
              </p>
            </div>

            {/* Email */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 text-center hover:shadow-xl transition-transform transform hover:scale-105 duration-300 select-none">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 select-none">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 sm:mb-3 select-none">Email Us</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed select-none">
                Newgmcceramic@gmail.com<br />
                We reply within 24 hours
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl mx-auto select-none">
            <div className="text-center mb-8 sm:mb-12 select-none">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">
                Send Us a <span className="text-orange-600">Message</span>
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto select-none">
                Have a question or need expert advice? Fill out the form below and our team will get back to you promptly.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="bg-gray-50 rounded-xl p-4 sm:p-6 lg:p-8 shadow-lg select-none">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                {/* Name */}
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Enter your full name"
                  />
                  {errors.name && <p className="text-red-500 text-xs sm:text-sm mt-1 select-none">{errors.name}</p>}
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Enter your email address"
                  />
                  {errors.email && <p className="text-red-500 text-xs sm:text-sm mt-1 select-none">{errors.email}</p>}
                </div>

                {/* Phone */}
                <div>
                  <label htmlFor="phone" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
                    placeholder="Enter your phone number"
                  />
                  {errors.phone && <p className="text-red-500 text-xs sm:text-sm mt-1 select-none">{errors.phone}</p>}
                </div>

                {/* Product Interest */}
                <div>
                  <label htmlFor="productInterest" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                    Product Interest
                  </label>
                  <select
                    id="productInterest"
                    name="productInterest"
                    value={formData.productInterest}
                    onChange={handleChange}
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 border-gray-300"
                  >
                    <option value="">Select a product category</option>
                    {productCategories.map((category, index) => (
                      <option key={index} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Subject */}
              <div className="mb-4 sm:mb-6">
                <label htmlFor="subject" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className={`w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 ${errors.subject ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Enter the subject of your inquiry"
                />
                {errors.subject && <p className="text-red-500 text-xs sm:text-sm mt-1 select-none">{errors.subject}</p>}
              </div>

              {/* Message */}
              <div className="mb-6 sm:mb-8">
                <label htmlFor="message" className="block text-gray-700 font-semibold text-sm sm:text-base mb-1 sm:mb-2 select-none">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4 sm:rows-5 lg:rows-6"
                  className={`w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-1 hover:border-orange-500 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors duration-300 ${errors.message ? 'border-red-500' : 'border-gray-300'}`}
                  placeholder="Please provide details about your requirements, project size, timeline, or any specific questions..."
                ></textarea>
                {errors.message && <p className="text-red-500 text-xs sm:text-sm mt-1 select-none">{errors.message}</p>}
              </div>

              {/* Submit Button */}
              <div className="text-center select-none">
                <button
                  type="submit"
                  className="w-full sm:w-auto bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 sm:px-8 lg:px-12 py-2.5 sm:py-3 lg:py-4 rounded-lg text-sm sm:text-base lg:text-lg transition-all duration-300 transform hover:scale-105 select-none"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-100 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 select-none">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">
              Find <span className="text-orange-600">Our Location</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto select-none">
              Visit our showroom to see our complete tile collection
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden select-none">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6659.813272857702!2d70.9630563060003!3d22.74062967962758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395991b3811db8d7%3A0xc6dd5990b63ed918!2sGmc%20Ceramic!5e1!3m2!1sen!2sin!4v1759207818112!5m2!1sen!2sin"
              width="100%"
              height="600"
              style={{ border: 0, minHeight: '600px', height: '600px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-50 to-orange-100 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 select-none">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">
              Frequently Asked <span className="text-orange-600">Questions</span>
            </h2>
          </div>
          <div className="max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl mx-auto select-none">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 select-none">
              {[
                {
                  question: "Do you provide installation services?",
                  answer: "Yes, we have certified installation professionals who ensure perfect tile laying with warranty coverage.",
                },
                {
                  question: "What is your delivery timeline?",
                  answer: "Standard delivery is 7-10 days within Gujarat and 10-15 days for other states, depending on order size.",
                },
                {
                  question: "Do you offer bulk discounts?",
                  answer: "Yes, we provide attractive pricing for bulk orders and contractor projects. Contact us for custom quotes.",
                },
                {
                  question: "Can I see samples before ordering?",
                  answer: "Absolutely! Visit our showroom or request sample tiles to be delivered to your location.",
                },
              ].map((faq, index) => (
                <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-lg select-none">
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 sm:mb-3 select-none">{faq.question}</h3>
                  <p className="text-sm sm:text-base text-gray-600 select-none">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contact;